<template>
  <main class="reports">
    <h1 class="marked">{{ $t('views.Reports.newReports') }}</h1>
    <i18next path="views.Reports.citcReports" tag="p" class="reports-text">
      <a
        :href="
          isEng
            ? 'https://www.citc.gov.sa/en/indicators/Pages/MEQYAS.aspx'
            : 'https://www.citc.gov.sa/ar/indicators/Pages/MEQYAS.aspx'
        "
        target="_blank"
        place="link"
      >
        {{ $t('common.link') }}
      </a>
    </i18next>

    <div v-if="!sortedReports.length" class="content-min-height">
      <Spinner />
    </div>

    <h1 class="marked">{{ $t('views.Reports.archivedReports') }}</h1>

    <section class="posts">
      <PostThumb
        v-for="post in displayedPosts"
        :post="post"
        :key="`post-${post.data.path}`"
      />
    </section>
  </main>
</template>
<script>
import { mapState } from 'vuex';
import Spinner from '@/components/Spinner';
import Button from '@/components/Button';
import PostThumb from '@/components/PostThumb';

export default {
  components: {
    Spinner,
    Button,
    PostThumb
  },
  metaInfo() {
    return {
      title: this.$t('views.Reports.title')
    };
  },
  data() {
    return {
      activeTag: undefined
    };
  },
  computed: {
    ...mapState(['reports']),
    sortedReports() {
      return this.reports
        .slice()
        .sort((a, b) => new Date(b.data.release) - new Date(a.data.release));
    },
    sortedReportsWithTag() {
      if (!this.activeTag) {
        return;
      }
      return this.reports
        .slice()
        .filter(post => post.tags.find(tag => tag === this.activeTag))
        .sort((a, b) => new Date(b.data.release) - new Date(a.data.release));
    },
    displayedPosts() {
      if (this.sortedReportsWithTag) {
        return this.sortedReportsWithTag;
      } else {
        return this.sortedReports;
      }
    },
    tags() {
      if (!this.reports.length) {
        return;
      }
      return this.reports.reduce((allTags, post) => {
        if (post.tags.length) {
          post.tags.forEach(tag => {
            if (!allTags.find(allTag => allTag === tag)) {
              allTags.push(tag);
            }
          });
        }

        return allTags;
      }, []);
    },
    isEng() {
      return this.$skI18n.locale === 'en-GB';
    }
  },
  watch: {
    reports(newReports, oldReports) {
      // Refetch reports when language changed
      if (oldReports.length && !newReports.length) {
        this.$store.dispatch('getReports');
      }
    }
  },
  serverPrefetch() {
    return this.$store.dispatch('getReports');
  },
  mounted() {
    if (!this.reports.length) {
      this.$store.dispatch('getReports');
    }
    if (window && window.PrismicToolbar) {
      window.PrismicToolbar.setupEditButton();
    }
  },
  methods: {
    handleTagChange(tag) {
      this.activeTag = tag;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/base/colors';
@import '../../scss/helpers/mixins';

.reports.reports {
  max-width: 1000px;
  margin: 0 auto;
  padding: 80px 20px 30px;
}

.reports-text {
  font-size: 20px;
}

.posts ::v-deep .post {
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 20px;
  padding-right: 20px;

  &:not(:last-child) {
    border-bottom: 1px $grey-3 solid;
  }

  h3::after {
    display: none;
  }
}

@include breakpoint(S) {
  .posts {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;

    ::v-deep .post {
      width: 50%;
      margin-left: 0;
      margin-right: 0;
      padding: 0 15px;

      &:not(:last-child) {
        border-bottom: none;
      }

      h3::after {
        display: block;
      }
    }
  }
}

@include breakpoint(M) {
  .reports.reports {
    padding-top: 146px;
  }

  .posts .post {
    width: 33.3%;
  }
}
</style>
